import Editor from "components/editor/Editor";
import ForumTopicCard from "components/forum/ForumTopicCard";
import parseISO from "date-fns/parseISO";
import type { IPostRepliesQuery } from "lib/graphql/queries/engagement/__generated__/PostRepliesQuery.generated";
import { CheckCircleIcon } from "lucide-react";
import { FormattedDate, FormattedMessage } from "react-intl";

interface ForumTopicQuestionCardProps {
  topic: NonNullable<IPostRepliesQuery["postByShortId"]>;
  onReply: () => void;
}

export function ForumTopicQuestionCard({ topic, onReply }: ForumTopicQuestionCardProps) {
  if (topic.__typename !== "ForumPost") {
    return null;
  }

  return (
    <ForumTopicCard
      topic={topic}
      postShortId={topic.shortId}
      url={topic.url}
      contextKey={topic.contextKey}
      contextType={topic.contextType}
      onReply={onReply}
    >
      {topic.replyAnswer && (
        <div key={`reply-answer/${topic.replyAnswer.shortId}`} className="col-span-3 -mx-4 -mb-8 md:-mx-8">
          <div className="col-span-3 flex w-full flex-col space-y-5 rounded-bl rounded-br bg-green-200 p-8 dark:bg-green-900/30">
            <div className="flex items-center space-x-2">
              <CheckCircleIcon className="size-8 fill-transparent stroke-green-600 dark:fill-transparent dark:stroke-green-400" />

              <span className="text-sm font-medium text-green-700 dark:text-green-400">
                <FormattedMessage defaultMessage="Respondido por" id="ta1XgS" />{" "}
                <strong className="font-black">{topic.replyAnswer.author.fullName}</strong>
              </span>

              <span className="text-sm capitalize text-gray-600 dark:text-gray-400">
                <FormattedDate value={parseISO(topic.replyAnswer.createdAt)} />
              </span>
            </div>

            <div>
              <Editor className="bg-inherit" editable={false} initialState={topic.replyAnswer.bodyAsJson} />
            </div>
          </div>
        </div>
      )}
    </ForumTopicCard>
  );
}
